export default "__VITE_ASSET__f6ac3452__"